import {Box, CardMedia, Container, Divider, Grid, Link as MUILink, Stack, Typography} from "@mui/material";
import {Link} from "react-router-dom";
import {Facebook, Instagram, Twitter} from "@mui/icons-material";
import logo from "../../assets/images/logo.png";

const Footer = () => {
    return (
        <Box sx={{backgroundColor: "background.alternative", borderTopRightRadius: 32, borderTopLeftRadius: 32, pt: 8, pb: 3}}>
            <Container maxWidth="xl">
                <Grid sx={{justifyContent: {xs: "center", md: "flex-start"}}} container={true} spacing={4}>
                    <Grid item={true} xs={12} md={6} lg={3}>
                        <Box>
                            <Link to="/" style={{textDecoration: "none"}}>
                                <CardMedia
                                    component="img"
                                    sx={{height: 150, objectFit: "contain", width: 150, mb: 4}}
                                    src={logo}
                                />
                            </Link>
                            <Stack spacing={1}>
                                <Typography component="span" variant="body2" sx={{color: "text.secondary"}}>
                                    World Support Foundation is a non-profit grant foundation committed to making a
                                    positive and lasting impact on communities worldwide. Our foundation was established
                                    with the vision of creating a better world...
                                </Typography>
                            </Stack>

                        </Box>
                    </Grid>
                    <Grid item={true} xs={12} md={6} lg={3}>
                        <Box>
                            <Typography variant="body2" sx={{color: "text.primary", mb: 2}}>
                                Quick Links
                            </Typography>
                            <Stack spacing={1}>
                                <Link to="/about" style={{textDecoration: "none"}}>
                                    <Typography component="span" variant="body2" sx={{color: "text.secondary"}}>
                                        Home
                                    </Typography>
                                </Link>
                                <Link to="/contact" style={{textDecoration: "none"}}>
                                    <Typography component="span" variant="body2" sx={{color: "text.secondary"}}>
                                        About Us
                                    </Typography>
                                </Link>
                                <Link to="/help" style={{textDecoration: "none"}}>
                                    <Typography component="span" variant="body2" sx={{color: "text.secondary"}}>
                                        Contact
                                    </Typography>
                                </Link>
                            </Stack>

                        </Box>
                    </Grid>
                    <Grid item={true} xs={12} md={6} lg={3}>
                        <Box>
                            <Typography variant="body2" sx={{color: "text.primary", mb: 2}}>
                                Grant Programs
                            </Typography>
                            <Stack spacing={1}>
                                <Link to="/apply" style={{textDecoration: "none"}}>
                                    <Typography component="span" variant="body2" sx={{color: "text.secondary"}}>
                                        Apply Now
                                    </Typography>
                                </Link>
                            </Stack>

                        </Box>
                    </Grid>
                    <Grid item={true} xs={12} md={6} lg={3}>
                        <Box>
                            <Typography variant="body2" sx={{color: "text.primary", mb: 2}}>
                                Contact us
                            </Typography>
                            <Stack spacing={1}>
                                <MUILink href="tel://+7 499 112-44-550" style={{textDecoration: "none"}}>
                                    <Typography component="span" variant="body2" sx={{color: "text.secondary"}}>
                                        +7 499 112-44-550{" "}
                                        <Typography
                                            component="span"
                                            variant="body2"
                                            sx={{color: "text.secondary", fontSize: 10}}>
                                            (Moscow)
                                        </Typography>
                                    </Typography>
                                </MUILink>
                                <MUILink href="tel://+7 499 112-44-550" style={{textDecoration: "none"}}>
                                    <Typography component="span" variant="body2" sx={{color: "text.secondary"}}>
                                        +8 800 200-60-57{" "}
                                        <Typography
                                            component="span"
                                            variant="body2"
                                            sx={{color: "text.secondary", fontSize: 10}}>
                                            (RF)
                                        </Typography>
                                    </Typography>
                                </MUILink>
                                <Stack spacing={1} direction="row" alignItems="center">
                                    <Facebook
                                        sx={{
                                            borderWidth: 1,
                                            borderColor: "icon.border",
                                            borderStyle: "solid",
                                            backgroundColor: "icon.background",
                                            fontSize: 32,
                                            padding: 1,
                                            color: "icon.secondary",
                                            borderRadius: "100%"
                                        }}
                                    />
                                    <Twitter
                                        sx={{
                                            borderWidth: 1,
                                            borderColor: "icon.border",
                                            borderStyle: "solid",
                                            backgroundColor: "icon.background",
                                            fontSize: 32,
                                            padding: 1,
                                            color: "icon.secondary",
                                            borderRadius: "100%"
                                        }}
                                    />
                                    <Instagram
                                        sx={{
                                            borderWidth: 1,
                                            borderColor: "icon.border",
                                            borderStyle: "solid",
                                            backgroundColor: "icon.background",
                                            fontSize: 32,
                                            padding: 1,
                                            color: "icon.secondary",
                                            borderRadius: "100%"
                                        }}
                                    />
                                </Stack>
                            </Stack>

                        </Box>
                    </Grid>
                </Grid>
                <Divider sx={{my: 3}} variant="fullWidth" light={true}/>
                <Typography variant="body2" align="center" sx={{color: "text.secondary"}}>
                    All rights Reserved - World Support Foundation
                </Typography>
            </Container>
        </Box>
    )
}
export default Footer;